import { Outlet, useLocation } from 'react-router-dom'
import { RequireEmailModal } from '@/app/entities/me/ui'
import { ToastProvider, ToastViewport } from '@/common/ui/Toast/ToastProvider'
import { useSyncNavigationHistory } from './navigationHistory'

/** Синхронизирует стек навигации (PUSH/REPLACE/POP) для resolveReturnPath и аналогичных сценариев. */
export const NavigationStackGuard = () => {
    const location = useLocation()
    useSyncNavigationHistory(location)

    return (
        <>
            <ToastProvider>
                <RequireEmailModal />
                <ToastViewport />
            </ToastProvider>
            <Outlet />
        </>
    )
}
